var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarshals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8184 1.35182C13.5041 1.302 12.5202 1.42602 10.3268 1.03719C8.57559 0.726622 7.00008 0.197266 7.00008 0.197266C7.00008 0.197266 5.96756 0.691883 3.92928 1.03719C1.39269 1.46667 0.181556 1.35182 0.181556 1.35182C0.181556 1.35182 -0.508922 9.30202 0.803201 11.9255C1.81029 13.9391 6.0823 15.5544 6.99985 15.8886C7.9174 15.5545 12.1897 13.9394 13.1968 11.9255C14.509 9.30168 13.8184 1.35182 13.8184 1.35182H13.8184ZM11.8909 11.1539C11.0959 12.7433 7.72436 14.0177 7.00012 14.2816C6.27581 14.0177 2.90437 12.7432 2.10965 11.1538C1.0736 9.0831 1.61869 2.80856 1.61869 2.80856L6.99982 1.86926L12.3816 2.80856C12.3816 2.80869 12.9267 9.0834 11.8909 11.1541V11.1539Z",
    fill: "#636F7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24537 2.47803C7.24537 2.47803 6.6932 13.3356 7.2455 13.6081C7.8939 13.372 10.912 12.2312 11.6235 10.8084C12.5502 8.95534 12.0625 3.33846 12.0625 3.33846L7.24537 2.47803Z",
    fill: "#636F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarshals);
export default __webpack_public_path__ + "static/media/Marshals.1f7cefaf5aba4e82f222ee69b0682c8f.svg";
export { ForwardRef as ReactComponent };